/* hide-cmapi:
 *
 * Hide cmapi from model list
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  $(function () {
    $(doc).on("bb:preHandleData", function (event, data) {
      if (data && data.models && data.models.length) {
        data.models = data.models.filter(function (m) {
          return m.modelname !== "cmapi";
        });
      }
    });
  });
})(jQuery, window, document);
